import keyMirror from 'keymirror';

export const codingProblemTypes = [
  'SCR',
  'MLI',
  'DSC',
  'SEL',
  'DBA',
  'UIX',
  'PRJ',
];

export const problemTypes = keyMirror({
  APP: null,
  DBA: null,
  MOB: null,
  MCQ: null,
  SUB: null,
  SHL: null,
  UIX: null,
  MLI: null,
  DSC: null,
  SEL: null,
  PRJ: null,
  FIB: null,
  SCR: null,
  VID: null,
  FBE: null,
  DJP: null,
  PFE: null,
  PBD: null,
  PBE: null,
  PFS: null,
  PBT: null,
  ADO: null,
  TEX: null,
  CMP: null,
});

export const problemLabel = {
  [problemTypes.APP]: 'Full-stack',
  [problemTypes.DBA]: 'Database',
  [problemTypes.MOB]: 'Mobile',
  [problemTypes.MCQ]: 'MCQ',
  [problemTypes.SUB]: 'Subjective',
  [problemTypes.SHL]: 'Shell-based',
  [problemTypes.UIX]: 'UI / UX',
  [problemTypes.MLI]: 'Machine Learning / AI',
  [problemTypes.DSC]: 'Data Science',
  [problemTypes.SEL]: 'Selenium Testing',
  [problemTypes.PRJ]: 'Task-based',
  [problemTypes.FIB]: 'Fill in the blanks',
  [problemTypes.SCR]: 'Coding',
  [problemTypes.VID]: 'Video',
  [problemTypes.ADO]: 'Audio',
  [problemTypes.TEX]: 'Text',
  [problemTypes.DJP]: 'DataScience Jupyter',
  [problemTypes.FBE]: 'File Based Evaluation',
  [problemTypes.PBE]: 'Project Based : BackEnd',
  [problemTypes.PFS]: 'Project Based : FullStack',
  [problemTypes.PFE]: 'Project Based : FrontEnd',
  [problemTypes.PBT]: 'Project Based : Automation Testing',
  [problemTypes.PBD]: 'Project Based : DevOps',
  [problemTypes.CMP]: 'Comprehension',
};

// Allowlist (not a denylist of unsupported types) so a newly added problem
// type is excluded from the single-page start flow by default until vetted.
export const SINGLE_PAGE_ASSESSMENT_ALLOWED_PROBLEM_TYPES = [
  problemTypes.MCQ,
  problemTypes.SUB,
  problemTypes.DBA,
  problemTypes.FIB,
  problemTypes.SCR,
  problemTypes.MLI,
  problemTypes.DSC,
  problemTypes.UIX,
  problemTypes.PRJ,
  problemTypes.FBE,
];

export const problemDifficultyLevel = {
  EAS: 'Easy',
  MED: 'Medium',
  HAR: 'Hard',
};

export const evaluationTypes = keyMirror({
  TXT: null,
  ATF: null,
});
export const evaluationModes = {
  [problemTypes.SCR]: [
    {
      value: evaluationTypes.TXT,
      label: 'I/O testcase based',
    },
    {
      value: evaluationTypes.ATF,
      label: 'Automated Testing Framework',
    },
  ],
  [problemTypes.DBA]: [
    {
      value: evaluationTypes.TXT,
      label: 'SELECT query based',
    },
    {
      value: evaluationTypes.ATF,
      label: 'DDL / DML query based',
    },
  ],
};

export const problemSubTypes = {
  [problemTypes.MCQ]: {
    types: keyMirror({
      0: 0,
      1: 1,
    }),
    label: {
      0: 'Single',
      1: 'Multiple',
    },
    field_name: 'is_multi_correct',
  },
};
/**
 * This is the primary Array that the Solution page uses to determine whether
 * a problem can be grouped or not. Any change to this array will have a
 * drastical effect on how to problems are grouped and how the Solution
 * page is rendered
 */
export const problemTypesGroupable = [
  problemTypes.MCQ,
  problemTypes.SUB,
  problemTypes.FIB,
  problemTypes.ADO,
  problemTypes.TEX,
];

export const OPTIMIZED_SHORT_TYPE_PROBLEMS = {
  MCQ: 'MCQ',
};

export const CLUSTER_TYPE_PROBLEMS = {
  CMP: 'CMP',
};
